export default __webpack_public_path__ + "static/medicare-0577e81320a1d31a4cd3cfe0f6c79666.svg";